import axios from '@/axios'

// grade subjects

export async function listGradeSubjects (gradeId) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/grades/' + gradeId + '/subjects')
  return response.data.data
}

export async function newGradeSubject (gradeId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/grades/' + gradeId + '/subjects', data)
  return response.data.data
}

export async function getGradeSubject (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/grade-subjects/' + id)
  return response.data.data
}

export async function updateGradeSubject (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/grade-subjects/' + id, data)
  return response.data.data
}

export async function deleteGradeSubject (id) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/grade-subjects/' + id)
  return response.data.data
}

export default {
  listGradeSubjects,
  newGradeSubject,
  getGradeSubject,
  updateGradeSubject,
  deleteGradeSubject
}
